import i18n from "../i18n";
import { isServerMessage, serverMessage } from "../i18n/serverMessages";

type ReasonKey = "offline.serverRejected" | "offline.serverRejectedCode" | "offline.serverKeptFailing";

export interface LocalReason {
  reasonKey: ReasonKey;
  args?: Record<string, unknown>;
}

const isLocalReason = (value: unknown): value is LocalReason =>
  !!value && typeof value === "object" && typeof (value as LocalReason).reasonKey === "string";

export const localReason = (reasonKey: ReasonKey, args?: Record<string, unknown>): LocalReason => ({ reasonKey, args });

export function syncReason(serverState: unknown): string | undefined {
  if (typeof serverState === "string") return serverState;
  if (isServerMessage(serverState)) return serverMessage(serverState);
  if (isLocalReason(serverState)) return i18n.t(serverState.reasonKey, serverState.args);
  return undefined;
}
